import { StreetAddress } from "../ordering";
export const STREET_ADDRESS_KEY = "client_street_address";
export class StreetAddressStorageManager {
    constructor(country) {
        this.country = country;
    }
    store(streetAddress) {
        const streetAddressData = {
            street: streetAddress.street,
            streetNumber: streetAddress.streetNumber,
            city: streetAddress.city,
            postCode: streetAddress.postCode,
        };
        const streetAddressDataString = JSON.stringify(streetAddressData);
        localStorage.setItem(STREET_ADDRESS_KEY, streetAddressDataString);
    }
    restore() {
        const streetAddressDataString = localStorage.getItem(STREET_ADDRESS_KEY);
        if (streetAddressDataString === null) {
            return null;
        }
        const streetAddressData = JSON.parse(streetAddressDataString);
        return new StreetAddress({
            country: this.country,
            street: streetAddressData.street,
            streetNumber: streetAddressData.streetNumber,
            city: streetAddressData.city,
            postCode: streetAddressData.postCode,
        });
    }
}
